import { ReactNode } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../store/root-reducer';
import TeamsFilter from './teams-filter';
import { getTeamsAndMembersListRequest } from '../../../components/settings/components/users-and-teams/extra-actions';
import { resetGetTeamsAndMembersListRequest } from '../../../components/settings/components/users-and-teams/users-and-teams-slice';
import { TeamsAndUsersList } from '../../../components/settings/types/users-and-teams';

const mapStateToProps = (state: RootState) => ({
  teamsAndUsersList: state.usersAndTeams.teamsAndUsersList,

  getTeamsAndMembersListRequestStatus:
    state.usersAndTeams.getTeamsAndMembersListRequest.status,
  getTeamsAndMembersListRequestError:
    state.usersAndTeams.getTeamsAndMembersListRequest.error,
  getTeamsAndMembersListRequestMessage:
    state.usersAndTeams.getTeamsAndMembersListRequest.message,
});

const mapDispatchToProps = {
  sendGetTeamsAndMembersListRequest: () => getTeamsAndMembersListRequest(),
  resetGetTeamsAndMembersListRequest: () =>
    resetGetTeamsAndMembersListRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  shouldMakeInitialAPICall?: boolean;
  selectLabel?: string;
  btnClassName?: string;
  defaultSelectedUsers: number[];
  resetSelectedUserIds?: boolean;
  setResetSelectedUserIds?: (reset: boolean) => void;
  onUserIdsChange: (userIds: number[]) => void;
  data?: TeamsAndUsersList[];
  customSelectBox?: ReactNode;
  hideFooter?: boolean;
  transferClassName?: string;
  disabled?: boolean;
};

export default connector(TeamsFilter);
